<ng-container *transloco="let t">
  <app-close-relative-form
    [submitButtonText]="t('closeRelative/edit')"
    [simplePrimaryBtn]="true"
    (formSubmit)="editCloseRelative($event)"
  ></app-close-relative-form>
</ng-container>
